import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';
import type { ILocation } from '../pdf/Interfaces';
import { GlobalVariables } from '../pdf/GlobalVariables';

export interface IContextMenuState {
    location: ILocation | null;
}

export const contextMenuSlice = createSlice({
    name: 'contextMenu',
    initialState: {
        location: null,
    } as IContextMenuState,
    reducers: {
        close: state => {
            GlobalVariables.contextMenuAnchor = null;
            state.location = null;
        },
        show: (state, action: PayloadAction<ILocation>) => {
            state.location = action.payload;
        },
    },
});

export const { close, show } = contextMenuSlice.actions;
export const contextMenuLocation = (state: IGlobalStoreReducers) => state.contextMenu.location;

export default contextMenuSlice.reducer;
